import { render, staticRenderFns } from "./m-review-list.vue?vue&type=template&id=311a0d5b&scoped=true&"
import script from "./m-review-list.vue?vue&type=script&lang=js&"
export * from "./m-review-list.vue?vue&type=script&lang=js&"
import style0 from "./m-review-list.vue?vue&type=style&index=0&id=311a0d5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a0d5b",
  null
  
)

export default component.exports